import * as React from 'react';
import { useImage } from '../../utils/customHooks/useImage';
import type { ICheckBoxWithSubTitleProps } from './CheckBoxWithSubTitle';
import { CheckBoxWithSubTitle } from './CheckBoxWithSubTitle';
type ICheckBoxWithSubTitlePhotoWrapperProps = {
  imageName?: string;
} & Omit<ICheckBoxWithSubTitleProps, 'withPhoto' | 'photoUrl'>;

export const CheckBoxWithSubTitlePhotoWrapper = (props: ICheckBoxWithSubTitlePhotoWrapperProps) => {
  const { imageName, ...res } = props;
  const { img } = useImage({ imageName: imageName || '' });

  return <CheckBoxWithSubTitle withPhoto photoUrl={img} {...res} />;
};
